export const REDACTED_FRAGMENT = '[REDACTED BY THE ARCHIVE]';

export function fragmentDisplayText(fragment) {
  return fragment?.visibility === 'DECRYPTED'
    ? String(fragment.text || '')
    : REDACTED_FRAGMENT;
}

export function fragmentCount(fragments = []) {
  return fragments.filter((item) => item.visibility === 'DECRYPTED').length;
}

export function fragmentSource(fragment) {
  return String(fragment?.source || 'UNKNOWN SOURCE');
}
